import { login } from '../../features/login/actions/authActions';
import { confirm } from '../../utils/confirm';
import { removeUnloadHook } from '../../utils/unloadHooks';
import { clearTicketStateFromStorage } from '../../features/tickets/utils/session';
import getErrorStatus from '../../utils/getErrorStatus';
import * as types from '../actionTypes';

const SUPPORT_API_URL_PREFIX = "/api/";

const is401ErrorIsFromAuthenticatedApiRequest = (error) => (
  error
    && getErrorStatus(error) === 401
    && error.config && error.config.url.startsWith(SUPPORT_API_URL_PREFIX)
);

/**
 * Middleware for catch 401 responses
 * @param store
 */
const redirectToLoginIfUnauthorized = ({ dispatch }) => next => async action => {
  if (
    action.type.endsWith("_ERROR") &&
    action.type !== types.LOAD_AUTHENTICATION_STATUS_ERROR &&
    is401ErrorIsFromAuthenticatedApiRequest(action.error)
  ) {
    // Remove the beforeUnload hook
    removeUnloadHook(clearTicketStateFromStorage);

    await confirm("Your session has expired.", {
      title: "Session Expired",
      okLabel: "Continue to log in",
      cancelLabel: "Return to the home page",
      enableEscape: false
    }).then(() => {
      const { pathname, search } = window.location;
      login(`${pathname}${search}`);
    },() => {
      // confirm throws an error when the user cancels
      // so we can ignore the error safely.
      window.location.assign("/logout");
    });
  }
  return next(action);
};

export default redirectToLoginIfUnauthorized;
